<template> 
  <div>
    <v-layout column>
      <v-flex>
        <v-select
            v-model="selectedPeriodo"
            item-value="id"
            :items="periodos"
            item-text="desc"
            label='Elija el periodo'
            return-object
            @change="changeDate()">
          </v-select>
      </v-flex>
      <div v-if="selectedPeriodo.id === 0">
        <v-layout>
          <v-flex>
              <v-text-field v-model="selectedPeriodo.desde" label="Desde" type="date" prepend-icon="event"
                                  @input="desdeChanged"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
              <v-text-field v-model="selectedPeriodo.hasta" label="Hasta" type="date" prepend-icon="event"
                                  @input="hastaChanged"></v-text-field>
          </v-flex>
        </v-layout>    
      </div>
    </v-layout>
  </div>
</template>

<script>

import { subDays, startOfDay, endOfDay, startOfMonth, startOfYear, format } from 'date-fns'


export default {
  data: () => ({
    selectedPeriodo:
          {
            id:1,
            desc:'Hoy',
            desde: format(startOfDay(new Date()), 'YYYY-MM-DD HH:mm:ss'),
            hasta: format(endOfDay(new Date()), 'YYYY-MM-DD HH:mm:ss')
          }
    ,
    periodos: [
          {
            id:1,
            desc: 'Hoy',
            desde: format(new Date(), 'YYYY-MM-DD'),
            hasta: format(new Date(), 'YYYY-MM-DD')
          },
          {
            id:2,
            desc: 'Ayer',
            desde: format(subDays(new Date(), 1), 'YYYY-MM-DD'),
            hasta: format(subDays(new Date(), 1), 'YYYY-MM-DD')
          },
          {
            id:3,
            desc: 'Última Semana',
            desde: format(subDays(new Date(), 7), 'YYYY-MM-DD'),
            hasta: format(new Date(), 'YYYY-MM-DD')
          },
          {
            id:4,
            desc: 'Últimos 30 días',
            desde: format(subDays(new Date(), 30), 'YYYY-MM-DD'),
            hasta: format(new Date(), 'YYYY-MM-DD')
          },
          {
            id:5,
            desc: 'Este Mes',
            desde: format(startOfMonth(new Date()), 'YYYY-MM-DD'),
            hasta: format(new Date(), 'YYYY-MM-DD')
          },
          {
            id:6,
            desc: 'Este Año',
            desde: format(startOfYear(new Date()), 'YYYY-MM-DD'),
            hasta: format(new Date(), 'YYYY-MM-DD')
          },
          {
            id:7,
            desc: 'Último Año',
            desde: format(subDays(new Date(),365), 'YYYY-MM-DD'),
            hasta: format(new Date(), 'YYYY-MM-DD')
          },
          {
            id:0,
            desc: 'Personalizado',
            desde: format(new Date(), 'YYYY-MM-DD'),
            hasta: format(new Date(), 'YYYY-MM-DD')
          }
    ]
  }),
  props: {
    periodo: {
      type: Object
    },
  },
  created() {
    this.changeDate();
  },
  methods: {
    desdeChanged(newDate){
      this.selectedPeriodo.desde = newDate
    },
    hastaChanged(newDate){
      this.selectedPeriodo.hasta = newDate
    },
    changeDate () {
      this.$emit('update-periodo', this.selectedPeriodo)
    }
  }
}
</script>
